/* tslint:disable */
/* eslint-disable */
/**
 * Referentials API
 * API for managing referentials, including countries, civility titles, and nationalities.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReferentialWithKeyDto } from './ReferentialWithKeyDto';
import {
    ReferentialWithKeyDtoFromJSON,
    ReferentialWithKeyDtoFromJSONTyped,
    ReferentialWithKeyDtoToJSON,
    ReferentialWithKeyDtoToJSONTyped,
} from './ReferentialWithKeyDto';

/**
 * 
 * @export
 * @interface GetReferentialsByKeysResponse
 */
export interface GetReferentialsByKeysResponse {
    /**
     * 
     * @type {Array<ReferentialWithKeyDto>}
     * @memberof GetReferentialsByKeysResponse
     */
    referentials: Array<ReferentialWithKeyDto>;
}

/**
 * Check if a given object implements the GetReferentialsByKeysResponse interface.
 */
export function instanceOfGetReferentialsByKeysResponse(value: object): value is GetReferentialsByKeysResponse {
    if (!('referentials' in value) || value['referentials'] === undefined) return false;
    return true;
}

export function GetReferentialsByKeysResponseFromJSON(json: any): GetReferentialsByKeysResponse {
    return GetReferentialsByKeysResponseFromJSONTyped(json, false);
}

export function GetReferentialsByKeysResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReferentialsByKeysResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'referentials': ((json['referentials'] as Array<any>).map(ReferentialWithKeyDtoFromJSON)),
    };
}

export function GetReferentialsByKeysResponseToJSON(json: any): GetReferentialsByKeysResponse {
    return GetReferentialsByKeysResponseToJSONTyped(json, false);
}

export function GetReferentialsByKeysResponseToJSONTyped(value?: GetReferentialsByKeysResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referentials': ((value['referentials'] as Array<any>).map(ReferentialWithKeyDtoToJSON)),
    };
}

